import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgDanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0",
		"mask-type": "alpha",
		maskUnits: "userSpaceOnUse",
		x: 4,
		y: 4,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM22 34V30H26V34H22ZM22 14V26H26V14H22Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 0H48V48H0V0Z",
			fill: "#424D57"
		})
	})]
});
export default SvgDanger;
